import { useState } from "react";
import { MapPin } from "lucide-react";
import { DESTINATIONS } from "@/data/destinations";
import { inputCls } from "@/components/FormBits";

const norm = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

const match = (q) => {
  const n = norm(q);
  if (!n) return [];
  const starts = DESTINATIONS.filter(([c, p]) => norm(c).startsWith(n) || norm(p).startsWith(n));
  const contains = DESTINATIONS.filter(([c]) => !norm(c).startsWith(n) && norm(c).includes(n));
  return [...starts, ...contains].slice(0, 6);
};

export const DestinationInput = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const items = match(value);
  const show = open && items.length > 0 && !(items.length === 1 && items[0][0] === value);

  const pick = (city) => { onChange(city); setOpen(false); };
  const onKey = (e) => {
    if (!show) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((a) => (a + 1) % items.length); }
    if (e.key === "ArrowUp") { e.preventDefault(); setActive((a) => (a - 1 + items.length) % items.length); }
    if (e.key === "Enter") { e.preventDefault(); pick(items[active][0]); }
    if (e.key === "Escape") setOpen(false);
  };

  return (
    <div className="relative">
      <input
        id="dream" value={value} autoComplete="off" placeholder="Ex. : Tokyo, Maldives…"
        data-testid="step1-dream-destination-input" className={inputCls}
        onChange={(e) => { onChange(e.target.value); setOpen(true); setActive(0); }}
        onFocus={() => setOpen(true)} onBlur={() => setOpen(false)} onKeyDown={onKey}
      />
      {show && (
        <ul data-testid="dream-suggestions" className="absolute inset-x-0 top-full z-30 mt-2 overflow-hidden rounded-2xl border border-navy/10 bg-white py-1 shadow-[0_20px_40px_-20px_rgba(11,21,48,0.35)]">
          {items.map(([city, country], i) => (
            <li key={city}>
              <button
                type="button" data-testid={`dream-suggestion-${i}`}
                onMouseDown={(e) => { e.preventDefault(); pick(city); }}
                onMouseEnter={() => setActive(i)}
                className={`flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm transition-colors ${i === active ? "bg-ivory" : ""}`}
              >
                <MapPin className="h-4 w-4 shrink-0 text-gold-deep" />
                <span className="text-navy">{city}</span>
                <span className="ml-auto text-xs text-navy/50">{country}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
